import React from 'react';
import { Footer as VerUdsFooter, Button } from '@ver-uds/react';
import { Client } from '../Providers/OAuthParamsParser';
import dhsSeal from '../../images/dhs-seal.svg';

const ACCESSIBILITY_URL = 'https://www.uscis.gov/website-policies/accessibility';
const VIEWERS_URL = 'https://www.uscis.gov/website-policies/plug-ins';

export interface FooterProps {
  FEEDBACK_URL?: string;
}

export const FooterComponent = ({ FEEDBACK_URL }: FooterProps): JSX.Element => {
  return (
    <VerUdsFooter
      primarySection={
        <VerUdsFooter.Section
          leftSection={
            <VerUdsFooter.Nav>
              <a href="https://www.dhs.gov/" target="_blank" rel="noopener noreferrer">
                U.S. Department of Homeland Security
              </a>
              <a href="https://www.uscis.gov/" target="_blank" rel="noopener noreferrer">
                U.S. Citizenship and Immigration Services
              </a>
            </VerUdsFooter.Nav>
          }
          rightSection={
            <VerUdsFooter.Nav>
              <a href={ACCESSIBILITY_URL} target="_blank" rel="noopener noreferrer">
                Accessibility
              </a>
              <a href={VIEWERS_URL} target="_blank" rel="noopener noreferrer">
                Plug-ins
              </a>
            </VerUdsFooter.Nav>
          }
        />
      }
      secondarySection={
        <VerUdsFooter.Section
          leftSection={
            <VerUdsFooter.Nav>
              <a href="https://www.dhs.gov/" target="_blank" rel="noopener noreferrer">
                <img src={dhsSeal} alt="Department of Homeland Security (DHS) Seal" />
              </a>
            </VerUdsFooter.Nav>
          }
          rightSection={
            <VerUdsFooter.Nav>
              {FEEDBACK_URL && (
                <Button type="button" href={FEEDBACK_URL} as="a">
                  Provide Feedback
                </Button>
              )}
            </VerUdsFooter.Nav>
          }
        />
      }
    />
  );
};

const FooterContainer = ({ appName: app }: { appName?: Client }): JSX.Element => {
  let FEEDBACK_URL;

  if (app === Client.SAVE) {
    FEEDBACK_URL = 'mailto:savesystemfeedback@uscis.dhs.gov';
  }
  if (app === Client.EVERIFY) {
    FEEDBACK_URL = 'mailto:E-Verify@uscis.dhs.gov';
  }
  return <FooterComponent FEEDBACK_URL={FEEDBACK_URL} />;
};

export default FooterContainer;
